import { createContextualCan } from '@casl/react';
import { PermissionsContext } from '@Context/PermissionsContext';

const Can = createContextualCan(PermissionsContext.Consumer);

export default Can;
